import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "../reducers";
// import { api_data } from "../services/data.service";

const store = configureStore({
  reducer: rootReducer,
});

export default store;
